module.exports = __webpack_public_path__ + "img/rigthImage.09a6bcb9.png";